var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isNewStuffAvailable)?_c('div',{staticClass:"c-new-stuff-available"},[_c('span',{staticClass:"new-stuff-available--text",on:{"click":_vm.loadStuff}},[_vm._t("default")],2),_c('button',{staticClass:"new-stuff-available--close",on:{"click":_vm.close}},[_c('Close',{attrs:{"width":10,"height":10}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }